import { useChat } from "./ChatContext";
import { ChatIcon } from "./icons";

/** Topbar chat button + unread badge. */
export function ChatTrigger({ className = "" }: { className?: string }) {
  const { unread, openChat } = useChat();
  return (
    <button
      onClick={() => openChat()}
      className={`icon-btn ${className}`}
      title={unread > 0 ? `${unread} unread message${unread === 1 ? "" : "s"}` : "Messages"}
      aria-label="Messages"
    >
      <ChatIcon />
      {unread > 0 && (
        <span className="icon-badge bg-rose-500 text-white">
          {unread > 99 ? "99+" : unread}
        </span>
      )}
    </button>
  );
}
